function string_truncate(str, n, isHtml = true) {
  return str.length > n ? str.substr(0, n - 1) + (isHtml ? '&hellip;' : '\u2026') : str
}

function string_isNullOrEmpty(str) {
  return !str
}

function getStringOrDefault(str, defaultValue) {
  return string_isNullOrEmpty(str) ? defaultValue : str
}

export { string_truncate, string_isNullOrEmpty, getStringOrDefault }
